import React, {useEffect} from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import CreatePollModal from 'components/polls/CreatePollModal'
import { setShowCreatePollModal, setCloseCreatePollModal } from 'features/polls/pollSlice'
import PollFeed from 'components/polls/PollFeed'
import CreateButton from 'components/buttons/CreateButton'
import { MobilePageTitle } from 'components/main.styled'
import { Modal } from '@mui/material'
import { MUIModalWrap } from 'components/modal/modal.styled'
import { addAc } from 'features/auth/authSlice'
import { addAcFunc } from 'funcs/ac'

import SectionHelp from 'components/help/SectionHelp'
import { useTranslation } from 'react-i18next'

export default function Polls() {
  const { t: translate } = useTranslation()
    const { user, admin} = useSelector((state) => state.auth)
    const { showCreatePollModal } = useSelector((state) => state.poll)
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const dispatch = useDispatch()

    const handleCreatePoll = () => {
        dispatch(setShowCreatePollModal())
    }

    const handleClose = () => {
        dispatch(setShowCreatePollModal())
    }


    useEffect(() => {

        const dis = () => dispatch(addAc({
          type: 'polls', 
        }))
    
        addAcFunc('polls', dis)
    
      }, [])

  return (
    <PollsContainer>
        <MobilePageTitle>
            {
                translate("web:polls.polls")
            }
        </MobilePageTitle>

        { (user.isOrganization || admin[profileChurch._id] ) && (
            <HeaderActions>
                <CreateButton
                    handler={handleCreatePoll}
                    buttonText={translate("web:polls.createPoll")}
                    />
                <SectionHelp
                    title={translate('polls:accessibility.churchPolls')}
                    intro="Polls make it easy to ask a focused question and understand how your community responds."
                    options={[{
                        title: 'Create a poll',
                        description: 'Offer clear response choices so members can participate quickly and church leaders can see the overall direction.',
                        bestFor: 'Availability checks, preference questions, ministry feedback, and simple group decisions.',
                        features: ['Fast member participation', 'Results stay connected to the question', 'Useful for gathering structured feedback'],
                    }]}
                    footer="Use a poll for guidance and feedback—not for private, sensitive, or emergency decisions."
                    />
            </HeaderActions>
        )} 
        
        <PollFeed />

        <Modal  
            open={showCreatePollModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <MUIModalWrap> 
                <CreatePollModal />
            </MUIModalWrap>
        </Modal>
    </PollsContainer>
  )
}

const PollsContainer = styled.div`
    padding: 10px;
    overflow-y: scroll;
    @media (max-width: 768px) {
        padding: 10px;
    }
`

const HeaderActions = styled.div`
    display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding: 10px 0;
`
